import React from "react";

// import { SectionCards } from "@/uiComponents/components/dashboardui/section-cards";

import {
  SidebarInset,
  SidebarProvider,
} from "@/uiComponents/components/ui/sidebar";

import { ExpenseFilter } from "./Expense/ExpenseFilter";
import { PieChartBranch } from "@/uiComponents/components/dashboardui/PieChartBranch";
import { PieChartCategory } from "@/uiComponents/components/dashboardui/PieChartCategory";
import { ChartAreaInteractive } from "@/uiComponents/components/dashboardui/chart-area-interactive";
import Expenses from "./Expense/Expenses";
import { AddExpenseButton } from "@/utils/AddExpenseButton";

export default function Dashboard() {
  return (
    <SidebarProvider>
      <SidebarInset>
        <div className="flex flex-1 flex-col gap-2 ml-8 mr-4">
          <div>
            <h2 className="text-2xl font-semibold ">Dashboard</h2>
          </div>
          <div className="@container/main flex flex-1 flex-col gap-2">
            <div className="flex flex-col gap-4 py-4 md:gap-1 overflow-visible">
              <div className=" mt-0 z-10 rounded-sm  overflow-visible ">
                <ExpenseFilter height={12} />
              </div>
              <AddExpenseButton />

              <div className="  py-4 ">
                <ChartAreaInteractive />
              </div>
              <div className="sm:flex  py-3  ">
                <PieChartBranch />
                <PieChartCategory />
              </div>
              <div className="">
                <Expenses />
              </div>
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
